import { render, staticRenderFns } from "./NewAppt.vue?vue&type=template&id=65530f5a&"
import script from "./NewAppt.vue?vue&type=script&lang=js&"
export * from "./NewAppt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports